export enum GTMEvents {
    successfulSignup = "signup",
    login = "login",
    wsBroker = "ws_broker",
    rltBroker = "rlt_broker",
    pageView = "pageview"
}